import React from 'react';
import {
  ClipboardList,
  Users,
  ShieldCheck,
  Settings,
  Lightbulb,
} from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { differentials } from '../data/mock';

const iconMap = {
  ClipboardList: ClipboardList,
  Users: Users,
  ShieldCheck: ShieldCheck,
  Settings: Settings,
  Lightbulb: Lightbulb,
};

const Differentials = () => {
  return (
    <section className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/5 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-amber-500 font-semibold tracking-wider uppercase text-sm">
            Por Que Nos Escolher
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mt-4 mb-6">
            Diferenciais
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-8" />
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            O que nos torna a escolha certa para o seu projeto.
          </p>
        </div>

        {/* Differentials Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {differentials.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <Card
                key={item.id}
                className="bg-slate-800/30 border-slate-700 hover:border-amber-500/50 transition-all duration-300 group hover:transform hover:-translate-y-2"
              >
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-amber-500/10 flex items-center justify-center group-hover:bg-amber-500/20 transition-colors">
                      <Icon className="w-7 h-7 text-amber-500" />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-white mb-2 group-hover:text-amber-500 transition-colors">
                        {item.title}
                      </h3>
                      <p className="text-slate-400 text-sm leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Banner */}
        <div className="mt-16 bg-gradient-to-r from-amber-500/10 to-amber-600/10 border border-amber-500/20 rounded-2xl p-8 sm:p-12 text-center">
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            Pronto para começar seu projeto?
          </h3>
          <p className="text-slate-400 mb-6 max-w-xl mx-auto">
            Entre em contato conosco e descubra como podemos transformar sua visão em realidade.
          </p>
          <button
            onClick={() => {
              document.querySelector('#contato')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold px-8 py-4 rounded-lg transition-all duration-200 hover:scale-105"
          >
            Fale Conosco
          </button>
        </div>
      </div>
    </section>
  );
};

export default Differentials;
